import { Analyst } from './analyst.model';
import { capitalize } from '@utils/capitalize';

export interface Scenario {
  source: string;
  unifiedPublicationDate: string;
  sourcePublicationDate: string;
  type: string;
  subtype: string;
  zoneName: string;
  zoneAlias: string;
  basecase: string;
  weatherYear: string;
  pricePerYear: Record<number, number | null>;
  historicalPricePerYear: Record<number, number | null>;
  historicalCurrency?: string;
  historicalUnitRateCurrency?: string;
  historicalUnitRateTermYear?: string;
  analyst?: Analyst;
  pmoFileUrl?: string;
  pmoOriginalFileName?: string;
  ratesByYear?: Record<string, number>;
  unitRateCurrency?: string;
  unitRateTermYear?: string;
  thickness?: number;
}

export const getScenarioKey = (scenario: Scenario): string =>
  [
  scenario.zoneName + ' - ' + scenario.zoneAlias,
  scenario.source,
  scenario.sourcePublicationDate,
  scenario.basecase,
  'WY' + capitalize(scenario.weatherYear),
  scenario.subtype,
].join('-');
